import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-content-between w-full" }
const _hoisted_2 = { style: {"text-align":"left"} }
const _hoisted_3 = { class: "flex flex-wrap gap-3" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = ["onClick", "textContent"]

import { ref, toRefs } from 'vue';
import Calendar from 'primevue/calendar';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import { useUtilizationStore } from '@/store';
import { useDateTime } from '@/composables';
import { ClinicianInterface, SOWReportingTableInterface } from '@/types';
import ServiceProviderTimeUsageModal from './ServiceProviderTimeUsageModal.vue';

interface SOWReportingPropsInterface {
  sowData: SOWReportingTableInterface[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SOWReporting',
  props: {
    sowData: {}
  },
  setup(__props: any) {

const props = __props;
const { sowData } = toRefs(props);
const utilizationStore = useUtilizationStore();
const serviceProviderModalOpen = ref<boolean>(false);
const filterDate = ref<Date>(useDateTime().getMostRecentSunday());
const maxDate = ref<Date>(useDateTime().getMostRecentSunday());
const minDate = ref<Date>(new Date('2024-01-02'));
const selectedServiceProvider = ref<ClinicianInterface>();

const onDateSelect = async (value: Date) => {
  filterDate.value = value;
  await utilizationStore.updateSOWFilterDate(filterDate.value);
};

const openServiceProviderUtilizationModal = (serviceProvider: ClinicianInterface) => {
  selectedServiceProvider.value = serviceProvider;
  serviceProviderModalOpen.value = true;
};

const closeServiceProviderUtilizationModal = () => {
  serviceProviderModalOpen.value = false;
  selectedServiceProvider.value = undefined;
};

const displayNameSort = ({ clinician }) => clinician.display_name;

const exportCSV = async () => {
  await utilizationStore.getSOWReportingExportData();
  const headers = Object.keys(utilizationStore.sOWExportData[0] || {});
  const csvContent = `data:text/csv;charset=utf-8,${headers.join(',') + '\n'}${utilizationStore.sOWExportData
    .map((item) => Object.values(item).join(','))
    .join('\n')}`;

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `SOW_Reporting_Download_${useDateTime().generateTimestamp()}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, { class: "flex-none flex flex-column" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "inline-flex align-items-center" }, [
          _createElementVNode("span", { class: "material-icons text-color-blue mr-2" }, "query_stats"),
          _createElementVNode("h2", null, "SOW Reporting")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppButton, {
            type: "secondary",
            text: "CSV",
            "icon-left": "system_update_alt",
            onClick: exportCSV
          })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex pt-4" }, [
          _createElementVNode("h2", { textContent: 'SOW Reporting up to: ' })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Calendar), {
            modelValue: filterDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterDate).value = $event)),
            "show-icon": "",
            "disabled-days": [1, 2, 3, 4, 5, 6],
            "icon-display": "input",
            class: "mt-3 text-sm",
            "date-format": "MM dd, yy",
            "max-date": maxDate.value,
            "min-date": minDate.value,
            onDateSelect: onDateSelect
          }, null, 8, ["modelValue", "max-date", "min-date"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          scrollable: "",
          "scroll-height": "350px",
          value: _unref(sowData),
          "sort-field": "billed_hours_percent",
          "sort-order": -1
        }, {
          empty: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("No data to display", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "clinician",
              sortable: "",
              "sort-field": displayNameSort,
              "header-style": "flex: 0 1 28%",
              "body-style": "flex: 0 1 28%",
              header: "Service Provider"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("a", {
                  class: "font-semibold",
                  onClick: ($event: any) => (openServiceProviderUtilizationModal(data.clinician)),
                  textContent: _toDisplayString(data.clinician.display_name)
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "organization",
              "header-style": "flex: 0 1 41%",
              "body-style": "flex: 0 1 41%",
              sortable: "",
              header: "Organization"
            }),
            _createVNode(_component_Column, {
              field: "billed_hours_diff",
              header: "Hrs +/-",
              sortable: "",
              "header-class": "justify-content-center",
              "body-class": "flex-auto justify-content-center"
            }),
            _createVNode(_component_Column, {
              field: "billed_hours_percent",
              sortable: "",
              "header-class": "relative justify-content-center",
              "body-class": "percentage flex-auto justify-content-center"
            }, {
              header: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "%", -1)),
                _withDirectives(_createVNode(_component_Icon, {
                  name: "info",
                  class: "absolute right-0 top-0 mt-2 text-gray-400 text-base cursor-pointer"
                }, null, 512), [
                  [
                    _directive_tooltip,
                    'Comparison of Total Billed Hours to SOW Hrs/Wk x Weeks',
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ColumnGroup), { type: "footer" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Row), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      "footer-class": "text-right",
                      footer: "Totals:",
                      colspan: 2
                    }),
                    _createVNode(_component_Column, {
                      "footer-class": "text-center",
                      footer: _unref(utilizationStore)?.sOWTableTotals?.total_billed_hours_diff || 'N/A'
                    }, null, 8, ["footer"]),
                    _createVNode(_component_Column, {
                      "footer-class": "percentage text-center",
                      footer: _unref(utilizationStore)?.sOWTableTotals?.total_billed_hours_percent || '0'
                    }, null, 8, ["footer"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        (serviceProviderModalOpen.value)
          ? (_openBlock(), _createBlock(ServiceProviderTimeUsageModal, {
              key: 0,
              "service-provider": selectedServiceProvider.value as ClinicianInterface,
              "filter-date": filterDate.value,
              "report-type": "sow",
              onCancel: closeServiceProviderUtilizationModal
            }, null, 8, ["service-provider", "filter-date"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})